import ManagementHeader from 'components/management/molecules/ManagementHeader'
import i18n from 'utils/i18n'
import _ from 'lodash'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import React, { useEffect, useState } from 'react'
import { AppRoutes } from 'navigations/app-routes'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { listArrow } from 'styles/list'
import { constantsActive } from 'utils/constants/constants'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import LoadingComponent from 'components/atoms/Loading'
import { useSelector } from 'react-redux'
import { managementConstants } from 'services/redux/management/constants'
import { fetchManagementTeams } from 'scenes/management/employees/components/teams/_functions/teams'
import ListItem from 'components/atoms/ListItem'

const TeamsTeams = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	
	const _managementTeams = useSelector( state => {
		return state.management[managementConstants.TEAMS];
	} )
	
	const [ loading, setLoading ] = useState( true )
	const [ search, setSearch ] = useState('')
	
	const fetchTeams = () => {
		fetchManagementTeams({
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: setLoading.bind( this, false ),
		})
	}
	
	const openTeam =  ( team ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_EMPLOYEES_TEAMS_VIEW, {
			teamGuid: team.guid
		} );
	}
	
	const createTeam = () => {
		openTeam( {} );
	}
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.name }
				subtitle={ i18n.t('management:pages.teams.teams.subtitle', { count: item.employee_count } ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openTeam }
			/>
		)
	}
	
	useEffect( () => {
		return fetchTeams();
	}, [ isFocused ] )
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.teams.teams.input_search_team'),
					onChangeText: _.debounce( setSearch, 400 )
				}
			]}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TEAMS ) ? { onPress: createTeam } : null }
		/>
	);
	
	const filters = _.size( search ) > 2 ? [ {field: 'name', kind: 'contains', value: search } ] : null;
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	return (
		<ManagementGroupedThemeList
			header={ header }
			items={ _managementTeams }
			renderItem={ renderItem.bind( this ) }
			groupByKey={ 'active' }
			filters={ filters }
			groupByValues={ [
				constantsActive.YES,
				constantsActive.NO
			] }
		/>
	);
}

export default TeamsTeams
